// 特殊ユーザ用権限コード定数
export const PERMISSION_CODE = {
  // 管理者（全店舗・全メニュー閲覧可能）
  ADMIN: '01',
  // 鉄道法人店舗・品揃え分析のみ閲覧可能
  ASSORTMENT_ANALYSIS_RAILWAY_STORE_ONLY: '02',
  // 自店舗・品揃え分析のみ閲覧可能
  ASSORTMENT_ANALYSIS_OWN_STORE_ONLY: '03',
  // 全店舗・品揃え分析のみ閲覧可能
  ASSORTMENT_ANALYSIS_ALL_STORE: '04',
  // 鉄道法人部署所属（自店舗・全メニュー閲覧可能）
  RAILWAY_DEPARTMENT: '05',
} as const;
